<ng-template #splitterTemplate let-splitterDisplayInfo>
    <div class="table-resizer-column-splitter"
         [style.left.px]="splitterDisplayInfo.splitterX"
         [style.top.px]="splitterDisplayInfo.splitter.top"
         [style.height.px]="splitterDisplayInfo.splitter.height">
        <div class="table-resizer-column-splitter_sign"
             [style.top.px]="splitterDisplayInfo.signY">
            <svg class="table-resizer-column-splitter_sign-icon">
                <use xlink:href="#column-resize-h"></use>
            </svg>
        </div>
    </div>
</ng-template>
